import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useUser } from "../contexts/UserContext";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

const Login = () => {
  const { login } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.redirect || "/";
  const [form, setForm] = useState({ correo: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.correo, form.password);
      toast.success("¡Bienvenido de vuelta!");
      navigate(redirect);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al ingresar");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center bg-cream px-6 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6"><Logo size="large" /></div>
        <div className="bg-white border-2 border-black p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-10 w-10 bg-yolk border-2 border-black flex items-center justify-center">
              <LogIn className="h-4 w-4 text-black" />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-bold text-brand-ink">Ingresar</h1>
              <p className="text-xs text-gray-500">Bienvenido nuevamente</p>
            </div>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            <Field label="Correo" type="email" value={form.correo} onChange={(v) => setForm({...form, correo: v})} testid="login-correo" />
            <Field label="Contraseña" type="password" value={form.password} onChange={(v) => setForm({...form, password: v})} testid="login-password" />
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-chunky w-full bg-mint-deep text-white py-3.5 text-sm">
              {loading ? "Ingresando..." : "INGRESAR"}
            </button>
          </form>
          <p className="text-center text-sm text-gray-600 mt-6">
            ¿No tienes cuenta? <Link to="/registro" data-testid="login-go-register" className="text-mint-deep font-bold link-underline">Crear cuenta</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, type = "text", value, onChange, testid }) => (
  <div>
    <label className="block text-xs uppercase tracking-[0.2em] font-bold text-brand-ink mb-2">{label}</label>
    <input type={type} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} required className="w-full border-2 border-black px-4 py-3 text-sm focus:outline-none focus:border-mint-deep" />
  </div>
);

export default Login;
